var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "zr480nwn6a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#zr480nwn6a)",
    transform: "translate(-1269.000000, -345.000000) translate(1040.000000, 0.000000) translate(220.000000, 336.000000) translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M11.25 0c.828 0 1.5.672 1.5 1.5V12c0 .828-.672 1.5-1.5 1.5H1.5C.672 13.5 0 12.828 0 12V1.5C0 .672.672 0 1.5 0h9.75zm-.75 1.5H2.25c-.414 0-.75.336-.75.75v9c0 .414.336.75.75.75h8.25c.414 0 .75-.336.75-.75v-9c0-.414-.336-.75-.75-.75z",
    transform: "translate(3.000000, 2.250000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#383838",
    transform: "translate(3.000000, 2.250000) translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.75,
    height: 1.5,
    rx: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#383838",
    transform: "translate(3.000000, 2.250000) translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.75,
    height: 1.5,
    rx: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(3.000000, 2.250000) translate(3.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.75,
    height: 1.5,
    rx: 0.75
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.92a26b379ace0cc9f5672284918d370f.svg";
export { ForwardRef as ReactComponent };